var _circle, _ellipse, _path, _ellipse2, _ellipse3, _g, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.7162162162161962 54.50000000000006 421.01351351351343 456.43749999999994",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    width: "421.01351351351343px",
    height: "456.43749999999994px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Master/Composition/Space"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42,
    cy: 371,
    r: 42,
    fill: "#FFA9C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 201,
    cy: 275.5,
    rx: 170,
    ry: 169.5,
    fill: "#AED5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 124L104 157L71 190L38 157L71 124Z",
    fill: "#7A8DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character And Mask"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask",
    opacity: 0.278134,
    cx: 201,
    cy: 251.5,
    rx: 170,
    ry: 193.5,
    fill: "#0007E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_410_65892dd4212c-fb7d-43bd-9ef6-fde08999efef",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -88,
    y: 44,
    width: 515,
    height: 462,
    fill: "#ffffff"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask_2",
    cx: 169.405,
    cy: 275.075,
    rx: 256.983,
    ry: 230.696,
    fill: "#ffffff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_410_65892dd4212c-fb7d-43bd-9ef6-fde08999efef)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front",
    transform: "rotate(-27 34.6362 124.278) translate(34.6362 124.278) scale(1.5147058823529411 1.4423076923076923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front/Long"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair Back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5 27C60.6259 27 51 36.6259 51 48.5V69.5C51 80.5658 59.3599 89.679 70.1086 90.8685C70.1114 90.9197 70.1143 90.971 70.1173 91.0225H99.1173C103.701 86.5438 99.209 57.9923 95.762 45.2902C94.2125 34.9385 85.2833 27 74.5 27H72.5Z",
    fill: "#b58143"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9354 75.2443C80.411 79.1475 86.7736 81.0333 89.7603 80.2635C97.2496 78.333 97.9382 50.9351 92.1433 40.1339C86.3485 29.3328 56.5583 24.625 55.0568 46.0255C54.5356 53.4529 57.6544 60.0814 62.2623 65.4901L54 104H78L73.9354 75.2443Z",
    fill: "#dcae92"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair Front",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8812 46.1504C52.578 45.4614 53.2522 44.7947 53.9211 44.1981L53.8889 43.4207C53.8889 43.4207 61.4214 28 73.0014 28C84.5711 28 88.23 33.3787 91.3403 37.9508L91.3487 37.9631C89.7218 43.5452 84.8187 45.8037 79.2736 48.3579C76.8866 49.4574 74.3806 50.6117 71.9657 52.1095C71.0199 51.341 69.8137 50.8804 68.5 50.8804C65.4624 50.8804 63 53.3428 63 56.3804C63 59.418 65.4624 61.8804 68.5 61.8804C68.5838 61.8804 68.6671 61.8785 68.75 61.8748C69.8557 73.7528 69.4127 87.3173 66.1173 90.5371H37.1173C36.2848 76.0731 40.0264 71.947 43.8498 67.7307C47.4474 63.7635 51.1173 59.7166 51.1173 46.9028C51.3754 46.6506 51.6298 46.3991 51.8812 46.1505L51.8812 46.1504Z",
    fill: "#b58143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character Lower Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.353 326.343L280.302 506.186L329.901 658.228H349.486L270.648 326.343L206.353 326.343Z",
    fill: "#dcae92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.462 326.343C190.674 389.541 179.19 474.627 177.355 478.566C175.521 482.506 50.6775 578.76 50.6775 578.76L64.167 592.631C64.167 592.631 211.47 510.105 218.287 499.098C225.103 488.091 247.295 386.803 265.113 326.343H191.462Z",
    fill: "#dcae92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.073 642.568L349.191 632.857L274.153 326.343H196.776L256.073 642.568Z",
    fill: "#56919c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.939 556.383L131.019 625.851C131.019 625.851 227.521 524.579 243.541 493.691C259.561 462.803 272.343 326.343 272.343 326.343H178.446C178.446 326.343 171.464 446.394 169.033 451.981C166.602 457.568 69.939 556.383 69.939 556.383Z",
    fill: "#89c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Upper Body",
    transform: "rotate(-14 -3.60303 230.938) translate(-3.60303 230.938) scale(1.50390625 1.4491978609625669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upper Body/Turtle Neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.398 149.908C46.3285 143.963 60.9699 67.4497 60.9699 67.4497L82.8673 67.5319C82.8673 67.5319 57.8506 148.583 56.308 152.406C54.3041 157.372 57.708 164.587 60.0162 169.48C60.3733 170.237 60.7041 170.938 60.9847 171.567C57.782 173 56.2435 171.268 54.6216 169.442C52.7896 167.379 50.8512 165.197 46.288 167.32C44.525 168.14 42.8567 169.109 41.2269 170.057C35.5969 173.329 30.4249 176.336 23.3891 171.994C22.2737 171.306 21.0514 168.715 24.0047 166.69C31.3624 161.645 41.9654 152.815 43.398 149.908ZM227.821 120.095L199.493 92.4604L190.084 108.74L219.542 126.108C226.928 137.743 231.266 142.77 232.556 141.19C233.643 139.857 233.145 138.396 232.686 137.051C232.328 136.003 231.994 135.025 232.453 134.231C233.5 132.42 239.414 133.457 244.984 134.682C250.554 135.906 249.265 133.17 248.081 131.742C242.817 127.493 236.063 123.611 227.821 120.095Z",
    fill: "#dcae92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes Back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.695 5.33206L136.342 3.84889C149.964 52.0008 219.953 84.823 224.249 102.823C225.825 109.425 221.074 112.762 223.528 114.772L212.288 123C210.385 120.779 206.323 124.841 197.841 122C189.359 119.159 127.695 62.3479 127.695 5.33206Z",
    fill: "#c5cfd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes Front",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.316 -4.72105C110.112 -4.87515 108.201 -3.21358 108.046 -1.00982L107.637 4.84783C91.3633 17.3711 51.0297 54.7932 40.5193 124.457C39.4152 131.775 41.4119 135.694 43.0072 138.826C44.0985 140.968 45.002 142.742 44.5967 144.983L59.3064 149.043C59.3064 147.389 61.1603 146.13 63.552 144.506C67.0298 142.145 71.6448 139.012 73.3512 132.767C74.9687 126.848 77.3372 119.454 80.1669 111.229C80.4341 122.122 82.5 132.14 87.0001 140.438C98.2274 161.139 163.109 138.436 169.887 117.318C173.505 106.049 168.372 96.5882 161.584 84.0754C152.967 68.1922 141.683 47.3917 142.241 11.7336L142.961 1.43166C143.115 -0.772099 141.454 -2.68352 139.25 -2.83762L112.316 -4.72105Z",
    fill: "#f2f2f2"
  })))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 291,
    cy: 442,
    r: 42,
    fill: "#FFEBA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    opacity: 0.399135,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294 82L302 90L294 98L286 90L294 82Z",
    fill: "#2026A2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.5ff902c79c1f1a3e20c5ecafa66edbf9.svg";
export { ForwardRef as ReactComponent };